import { render, staticRenderFns } from "./AccountTransferView.vue?vue&type=template&id=2997d050&"
import script from "./AccountTransferView.vue?vue&type=script&lang=js&"
export * from "./AccountTransferView.vue?vue&type=script&lang=js&"
import style0 from "./AccountTransferView.vue?vue&type=style&index=0&id=2997d050&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports